import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { get } from '@/ports/api'
import { colors } from '@/styles'
import defaultThumbnailImage from './default-thumbnail.png'

const Thumbnail = styled.img`
  background: ${colors.lightGrey};
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 'center';
  display: block;
`
export const DefaultThumbnail = () => {
  return <Thumbnail src={defaultThumbnailImage} />
}

//https://blog.addpipe.com/10-advanced-features-in-html5-video-player/
export const VideoFileThumbnail = ({ sources = [], disabled }) => {
  //replicate old behaviour of displaying white thumbnail while disabled.
  if (disabled) return null
  return sources.length ? (
    <Thumbnail as="video" autoPlay={false} preload="metadata">
      {sources.map((item, index) => (
        <source key={index} src={item.key} type={item.type} />
      ))}
    </Thumbnail>
  ) : (
    <DefaultThumbnail />
  )
}

export const YoutubeThumbnail = ({ url }) => {
  const regex = new RegExp(
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*?[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/,
    'gi'
  )
  const videoId = url.match(regex)?.[0].split('/')[1].replace('watch?v=', '')
  return videoId ? (
    <Thumbnail src={`https://img.youtube.com/vi/${videoId}/0.jpg`} />
  ) : (
    <DefaultThumbnail />
  )
}

//https://developer.vimeo.com/api/oembed/videos
//https://coderwall.com/p/fdrdmg/get-a-thumbnail-from-a-vimeo-video
export const VimeoThumbnail = ({ url }) => {
  const [thumbnailSrc, setThumbnailSrc] = useState()
  useEffect(() => {
    const fetchResponse = async () => {
      try {
        const getThumbnail = get('https://vimeo.com/api/oembed.json', {
          defaultHeaders: {},
          credentials: 'omit',
          failSilently: true
        })
        const { body: data } = await getThumbnail({}, { url })
        setThumbnailSrc(data.thumbnail_url)
      } catch (e) {
        console.log(e)
      }
    }

    fetchResponse()
  }, [url])

  return thumbnailSrc ? <Thumbnail src={thumbnailSrc} /> : <DefaultThumbnail />
}

// Obtains the model from m= in a link like
// https://my.matterport.com/show/?m=roWLLMMmPL8
// Also obtains the real url from a embed link
const getMatterportModel = url => {
  const target = new URL(url ?? '')
  const params = target.searchParams
  const next = params.get('url')
  const model = params.get('m')
  return [model, next]
}

//https://stackoverflow.com/questions/42335148/get-matterport-thumbnail
export const MatterportThumbnail = ({ url }) => {
  const [model, next] = getMatterportModel(url)
  let modelId = model
  if (!model && next) {
    const [newModel] = getMatterportModel(next)
    modelId = newModel
  }
  if (!modelId) return <DefaultThumbnail />
  const src = `https://my.matterport.com/api/v1/player/models/${modelId}/thumb`
  return <Thumbnail src={src} />
}

//givin up on getting thumbnail, copying mobile and showing default image cuz it's too much effort
export const EyexpoThumbnail = ({ url }) => {
  return <DefaultThumbnail />
}

const videoThumbnails = {
  youtube: YoutubeThumbnail,
  vimeo: VimeoThumbnail,
  matterport: MatterportThumbnail,
  eyexpo: EyexpoThumbnail,
  metareal: DefaultThumbnail
}

export default videoThumbnails
